import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  userSignUp,
  sendSignUpOtp,
  verifySignUpOTP
} from "../../actions/signup.action";
import { ERROR_MSG, PATHS } from "../../constant";
import {
  userLogin,
  sendVerificationOTP,
  userSecurityKey
} from "../../actions/login.action";
import { bindActionCreators } from "redux";
import { PHONE_VALIDATE, EMAIL_VALIDATE, OTP_LENGTH } from "../../validation";
import { get, isFunction } from "lodash";
import { toast } from "react-toastify";
import { STATUS } from "../../constant";
import { LoaderPage } from "../../component/Loader";
import ReCaptcha from "../GoogleCaptcha/googleCaptcha";
import { setLocalstorage } from "../../helper";
import TooltipComponent from "../../component/TooltipComponent";
import { JSEncrypt } from "jsencrypt/lib";
import { successToastStyle, errorToastStyle } from "../../customToast";

export class RegistrationOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileDisabled: true,
      emailDisabled: true,
      mobileNumber: "",
      email: "",
      mobileOtp: "",
      emailOtp: "",
      errors: {},
      enableSendOtpForPhone: false,
      enableSendOtpForEmail: false,
      isWrongOtp: false,
      disableOtp: false,
      disabledOtpForEmail: false,
      disabledOtpForMobile: false
    };
  }

  componentDidMount() {
    this.setState(
      {
        disabledOtpForEmail: true,
        disabledOtpForMobile: true
      },
      () => this.disableOtp()
    );
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (
      prevProps.data.email !== data.email ||
      prevProps.data.mobileNumber !== data.mobileNumber
    ) {
      this.setState({ email: data.email, mobileNumber: data.mobileNumber });
    }
  }

  mobileClick = () => {
    this.setState({ mobileDisabled: false });
  };

  emailClick = () => {
    this.setState({ emailDisabled: false });
  };

  sendMobileOtpClick = async event => {
    const {
      mobileNumber,
      email,
      errors,
      disabledOtp,
      disabledOtpForMobile
    } = this.state;
    const { data, result } = this.props;
    const loginOtp = data.loginOtp;

    //
    if (disabledOtp || disabledOtpForMobile) {
      return;
    }

    this.validateField("mobileNumber", mobileNumber);
    const isInValid = errors.phoneValid && errors.phoneValid.error;
    if (!isInValid) {
      this.setState({
        mobileDisabled: true,
        enableSendOtpForPhone: false,
        disableOtp: true,
        disabledOtpForMobile: true
      });
      const data = {
        //email: email,
        service: "REGISTER",
        mobileNumber: mobileNumber
      };
      let otpResult = null;
      if (loginOtp) {
        otpResult = await sendVerificationOTP(undefined, {
          //email: email,
          service: "VERIFIED",
          mobileNumber: mobileNumber,
          userId: result && result.data.id
        });
      } else {
        otpResult = await sendSignUpOtp(undefined, data);
      }
      if (otpResult && otpResult.data.status) {
        toast.success(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          successToastStyle
        );
      } else if (otpResult && !otpResult.data.status) {
        toast.error(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          errorToastStyle
        );
      }
      this.props.changePhone(mobileNumber);
      this.disableOtp();
    }
  };

  sendEmailOtpClick = async event => {
    const {
      email,
      mobileNumber,
      errors,
      disabledOtp,
      disabledOtpForEmail
    } = this.state;
    const { data, result } = this.props;
    const loginOtp = data.loginOtp;

    //
    if (disabledOtp || disabledOtpForEmail) {
      return;
    }

    this.validateField("email", email);
    const isInValid = errors.emailValid && errors.emailValid.error;
    if (!isInValid) {
      this.setState({
        emailDisabled: true,
        enableSendOtpForEmail: false,
        disableOtp: true,
        disabledOtpForEmail: true
      });
      const data = {
        email: email,
        service: "REGISTER"
        //mobileNumber: mobileNumber
      };
      let otpResult = null;
      if (loginOtp) {
        otpResult = await sendVerificationOTP(undefined, {
          email: email,
          service: "VERIFIED",
          //mobileNumber: mobileNumber,
          userId: result && result.data.id
        });
      } else {
        otpResult = await sendSignUpOtp(undefined, data);
      }
      if (otpResult && otpResult.data.status) {
        toast.success(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          successToastStyle
        );
      } else if (otpResult && !otpResult.data.status) {
        toast.error(
          <p className="toast-text-alignment">{otpResult.data.message}</p>,
          errorToastStyle
        );
      }
      this.props.changeEmail(email);
      this.disableOtp();
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    switch (name) {
      case "mobileNumber":
        this.setState({
          enableSendOtpForPhone: true,
          disabledOtpForMobile: false
        });
        break;
      case "email":
        this.setState({
          enableSendOtpForEmail: true,
          disabledOtpForEmail: false
        });
        break;
      default:
        break;
    }
  };

  validateField = (fieldName, value) => {
    let { errors, mobileNumber, email, mobileOtp, emailOtp } = this.state;
    switch (fieldName) {
      case "mobileNumber":
        errors.phoneValid = PHONE_VALIDATE(value);
        break;
      case "email":
        errors.emailValid = EMAIL_VALIDATE(value);
        break;
      default:
        errors.phoneValid = PHONE_VALIDATE(mobileNumber);
        errors.emailValid = EMAIL_VALIDATE(email);
        errors.mobileOtpValid = OTP_LENGTH(mobileOtp);
        errors.emailOtpValid = OTP_LENGTH(emailOtp);
        break;
    }
    this.setState({
      errors: errors
    });
  };

  validateForm = () => {
    let { errors, enableSendOtpForEmail, enableSendOtpForPhone } = this.state;
    let { phoneValid, emailValid, mobileOtpValid, emailOtpValid } = errors;
    if (
      (phoneValid &&
        phoneValid.error &&
        emailValid &&
        emailValid.error &&
        mobileOtpValid &&
        mobileOtpValid.error &&
        emailOtpValid &&
        emailOtpValid.error) !== undefined &&
      !phoneValid.error &&
      !emailValid.error &&
      !mobileOtpValid.error &&
      !emailOtpValid.error &&
      !enableSendOtpForEmail &&
      !enableSendOtpForPhone
    ) {
      return true;
    }
    return false;
  };

  handleOtp = (name, otp) => {
    this.setState({ [name]: otp, isWrongOtp: false });
  };

  getSecurityKey = async () => {
    const { captchaToken } = this.state;
    const {
      userSecurityKey,
      data: { password }
    } = this.props;
    try {
      await userSecurityKey();
      const { securityKeyData, history } = this.props;
      if (get(securityKeyData, "id")) {
        let userID = get(securityKeyData, "id");
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(get(securityKeyData, "key"));
        const encryptedPassword = encrypt.encrypt(password);
        this.setState({ encryptedPassword, userID });
        this.handleOtpApi();
      } else {
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
        history.push(PATHS.SIGNUP);
      }
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    } catch (e) {
      console.log(`Error in OTP verification ${e.message}`);
    }
  };

  handleOtpApi = async () => {
    const { history, handleClose, data } = this.props;
    const {
      mobileOtp,
      emailOtp,
      email,
      mobileNumber,
      captchaToken,
      encryptedPassword,
      userID
    } = this.state;
    // this.validateField();
    // let isValidData = this.validateForm();
    data.mobileNumberCode = mobileOtp;
    data.emailCode = emailOtp;
    data.email = email;
    data.mobileNumber = mobileNumber;
    data.key = userID;
    data.password = encryptedPassword;
    //data.googleCaptchaToken = captchaToken;
    // if (isValidData) {
    delete data.encryptedPassword;
    this.setState({
      isApiLoading: STATUS.LOADING
    });
    try {
      let response = null;
      if (data.loginOtp) {
        response = await verifySignUpOTP(undefined, data);
      } else {
        response = await userSignUp(undefined, data);
      }
      this.setState({
        isApiLoading: STATUS.SUCCESS
      });
      if (response) {
        const { data } = response || {};
        try {
          (get(data, "status") &&
            toast.success(
              <p className="toast-text-alignment">{get(data, "message")}</p>,
              successToastStyle
            )) ||
            toast.error(
              <p className="toast-text-alignment">{get(data, "message")}</p>,
              errorToastStyle
            );
          if (get(data, "status")) {
            setLocalstorage("user", get(data, "data.user"));
            setLocalstorage("token", get(data, "data.jwtToken.accessToken"));
            setLocalstorage(
              "refreshToken",
              get(data, "data.jwtToken.refreshToken")
            );
            if (
              get(data, "data.user.groupCategory") === "PP" &&
              !get(data, "data.user.projectCreatedBy")
            ) {
              history.push(PATHS.CREATE_PROJECT);
            } else {
              history.push(PATHS.DASHBOARD);
            }
          }
        } catch (e) {}
        isFunction(handleClose) && handleClose();
      }
    } catch (e) {}
  };

  onCaptchaResolved = captchaToken => {
    this.setState({ captchaToken });
    (captchaToken && this.getSecurityKey()) ||
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_CAPTCHA}</p>,
        errorToastStyle
      );
  };

  onValidateCaptcha = event => {
    event.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData && this.captchaElement) {
      this.captchaElement.execute(this.captchaElementResetId);
    }
  };

  // keep otp send of
  disableOtp = () => {
    setTimeout(() => {
      this.setState({
        disabledOtp: false,
        disabledOtpForEmail: false,
        disabledOtpForMobile: false
      });
    }, 30000);
  };

  render() {
    const { show, handleCrossBtn, result, handleClose } = this.props;
    const {
      mobileDisabled,
      emailDisabled,
      mobileNumber,
      email,
      errors,
      enableSendOtpForEmail,
      enableSendOtpForPhone,
      isWrongOtp,
      isApiLoading,
      disabledOtp,
      disabledOtpForEmail,
      disabledOtpForMobile
    } = this.state;
    return (
      <Modal show={show} onHide={handleCrossBtn || handleClose}>
        <Modal.Header closeButton data-test="registration-otp-verify-modal" />
        <Modal.Body>
          {result && result.message && (
            <span className="success-msg">{result.message}</span>
          )}
          <LoaderPage loading={isApiLoading === STATUS.LOADING} />
          <Form className="verify-form">
            <Form.Group controlId="number">
              <Form.Label>Verify Mobile Number</Form.Label>
              <Form.Text className="verify-subhead">
                Please enter the 4-digit code sent to
              </Form.Text>
              <Form.Control
                type="text"
                name="mobileNumber"
                maxLength="10"
                value={mobileNumber}
                disabled={mobileDisabled}
                onChange={this.handleChange}
                onBlur={() => this.validateField("mobileNumber", mobileNumber)}
                isInvalid={errors.phoneValid && errors.phoneValid.error}
              />
              {mobileDisabled ? (
                <div className="edit-field" onClick={this.mobileClick} />
              ) : (
                enableSendOtpForPhone && (
                  <div
                    role="button"
                    aria-disabled={disabledOtpForMobile}
                    className={`btn-send-otp ${(disabledOtpForMobile &&
                      "optDisabled") ||
                      ""}`}
                    onClick={this.sendMobileOtpClick}
                  >
                    Send OTP
                  </div>
                )
              )}
              <Form.Control.Feedback type="invalid">
                {errors.phoneValid && errors.phoneValid.error
                  ? errors.phoneValid.message
                  : null}
              </Form.Control.Feedback>
              <div className="otp-label">Enter Code</div>
              <OtpInput
                containerStyle="otp-code"
                onChange={otp => this.handleOtp("mobileOtp", otp)}
              />
              <div
                className="invalid-feedback"
                data-test="mobile-otp-error-message"
              >
                {errors.mobileOtpValid && errors.mobileOtpValid.error
                  ? errors.mobileOtpValid.message
                  : null}
              </div>
              <Form.Text className="resend-otp">
                Didn't receive the OTP?
                <span
                  className={`${(disabledOtpForMobile && "otpDisabled") || ""}`}
                  onClick={this.sendMobileOtpClick}
                >
                  Resend OTP{" "}
                  {disabledOtpForMobile ? (
                    <TooltipComponent
                      classes="info-icon"
                      placement="left"
                      content={
                        <>
                          If you didn't receive the OTP, please try again after
                          30 seconds.
                        </>
                      }
                    />
                  ) : (
                    ""
                  )}
                </span>
              </Form.Text>
            </Form.Group>
            <Form.Group controlId="email">
              <Form.Label>Verify Email</Form.Label>
              <Form.Text className="verify-subhead">
                Please enter the 4-digit code sent to
              </Form.Text>
              <Form.Control
                type="email"
                name="email"
                value={email}
                disabled={emailDisabled}
                onChange={this.handleChange}
                onBlur={() => this.validateField("email", email)}
                isInvalid={errors.emailValid && errors.emailValid.error}
              />
              {emailDisabled ? (
                <div className="edit-field" onClick={this.emailClick} />
              ) : (
                enableSendOtpForEmail && (
                  <div
                    className={`btn-send-otp ${(disabledOtpForEmail &&
                      "optDisabled") ||
                      ""}`}
                    onClick={this.sendEmailOtpClick}
                  >
                    Send OTP
                  </div>
                )
              )}
              <Form.Control.Feedback type="invalid">
                {errors.emailValid && errors.emailValid.error
                  ? errors.emailValid.message
                  : null}
              </Form.Control.Feedback>
              <div className="otp-label">Enter Code</div>
              <OtpInput
                containerStyle="otp-code"
                onChange={otp => this.handleOtp("emailOtp", otp)}
              />
              <div
                className="invalid-feedback"
                data-test="email-otp-error-message"
              >
                {errors.emailOtpValid && errors.emailOtpValid.error
                  ? errors.emailOtpValid.message
                  : null}
              </div>
              <Form.Text className="resend-otp">
                Didn't receive the OTP?
                <span
                  className={`${(disabledOtpForEmail && "otpDisabled") || ""}`}
                  onClick={this.sendEmailOtpClick}
                >
                  Resend OTP{" "}
                  {disabledOtpForEmail ? (
                    <TooltipComponent
                      classes="info-icon"
                      placement="left"
                      content={
                        <>
                          If you didn't receive the OTP, please try again after
                          30 seconds.
                        </>
                      }
                    />
                  ) : (
                    ""
                  )}
                </span>
              </Form.Text>
            </Form.Group>
            {isWrongOtp ? (
              <p className="error">
                False OTP entered. Please enter correct OTP and retry
              </p>
            ) : null}
            <div
              className="verify-btn-container"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "520px"
              }}
            >
              <Button
                className="btn-shadow"
                onClick={handleCrossBtn || handleClose}
                data-test="cancel-button"
                style={{
                  color: "#DE3E28",
                  background: "white",
                  border: "1px solid #DE3E28",
                  margin: "10px 0px"
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={this.onValidateCaptcha}
                className="btn-orange"
                data-test="submit-button"
              >
                Validate
              </Button>
              <ReCaptcha
                id="recaptcha-4"
                getRef={ref => {
                  this.captchaElement = ref;
                }}
                onChange={this.onCaptchaResolved}
                resetId={id => {
                  this.captchaElementResetId = id;
                }}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

RegistrationOtp.propTypes = {
  history: PropTypes.shape({})
};

RegistrationOtp.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    loginResult: state.loginReducer.data,
    otpResult: state.loginReducer.otpData,
    securityKeyData: state.loginReducer.securityKeyData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userLogin: userLogin,
      userSignUp: userSignUp,
      sendSignUpOtp: sendSignUpOtp,
      userSecurityKey
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegistrationOtp)
);
